import React from "react";
import useCountUp from "../lib/useCountUp.js";

export default function PostureGauge({ score = 0, size = 180 }) {
  const clamped = Math.max(0, Math.min(100, score));
  const animScore = useCountUp(clamped, { duration: 1800 });
  const angle = (animScore / 100) * 180 - 90;
  const r = size / 2 - 14;
  const cx = size / 2;
  const cy = size / 2 + 10;

  const arc = (start, end, color, width) => {
    const a1 = (start * Math.PI) / 180;
    const a2 = (end * Math.PI) / 180;
    const x1 = cx + r * Math.cos(a1);
    const y1 = cy + r * Math.sin(a1);
    const x2 = cx + r * Math.cos(a2);
    const y2 = cy + r * Math.sin(a2);
    const largeArc = end - start > 180 ? 1 : 0;
    return (
      <path d={`M ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2}`} stroke={color} strokeWidth={width} fill="none" strokeLinecap="round" />
    );
  };

  return (
    <div className="relative inline-flex flex-col items-center" data-testid="posture-gauge">
      <svg width={size} height={size / 2 + 30}>
        <defs>
          <linearGradient id="gauge-bad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#EF4444" />
            <stop offset="100%" stopColor="#FB7185" />
          </linearGradient>
          <linearGradient id="gauge-mid" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#FB7185" />
            <stop offset="100%" stopColor="#FBBF24" />
          </linearGradient>
          <linearGradient id="gauge-good" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#FBBF24" />
            <stop offset="100%" stopColor="#84cc16" />
          </linearGradient>
          <linearGradient id="gauge-elite" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#4ade80" />
            <stop offset="100%" stopColor="#22d3ee" />
          </linearGradient>
        </defs>
        {arc(180, 210, "url(#gauge-bad)",   14)}
        {arc(210, 250, "url(#gauge-mid)",   14)}
        {arc(250, 320, "url(#gauge-good)",  14)}
        {arc(320, 360, "url(#gauge-elite)", 14)}
        <g style={{ transform: `rotate(${angle}deg)`, transformOrigin: `${cx}px ${cy}px`, transition: "transform 0.15s linear" }}>
          <line x1={cx} y1={cy} x2={cx} y2={cy - r + 6} stroke="#fff" strokeWidth={3} strokeLinecap="round" />
          <circle cx={cx} cy={cy} r={7} fill="#fff" />
          <circle cx={cx} cy={cy} r={3} fill="#0a1822" />
        </g>
      </svg>
      <div className="-mt-2 flex flex-col items-center">
        <div className="text-3xl font-bold ps-heading text-white ps-tabular" data-testid="posture-score-value">{animScore}</div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-bold ps-serif ps-italic">Posture Score™</div>
      </div>
      <div className="flex w-full justify-between text-[10px] text-slate-500 mt-1 px-2 ps-mono">
        <span>POOR</span><span>ELITE</span>
      </div>
    </div>
  );
}
